import React from 'react';

const HeaderWithLinkBackToLandingPage = () => {
    return (
        <section className='header'>
            <a href='https://farm-fresh-produce-site.netlify.com/'><h1>Farm Fresh</h1></a>
        </section>
    )
};

export default HeaderWithLinkBackToLandingPage;